// ─────────────────────────────────────────────────────────────────────────────
// Locally-created grievance store (DEMO persistence).
//
// v1 grievances come from the mock adapter (the future feed seam). Grievances a
// user CREATES in the app are kept here, in localStorage, so they survive a
// reload for demo/testing. When the real data-relay feed lands, creation will
// write through the relay and this local store is retired — reports/manager keep
// reading the same merged shape.
//
// Records written here conform to the shared grievanceModel shape (plus a few
// capture-only extras: incidentDate, relationToResident, filedBy, filedDate,
// actionNotes, attachments). They carry createdLocally:true so the UI can flag
// them as locally-entered.
// ─────────────────────────────────────────────────────────────────────────────

const STORAGE_KEY = "survai_metrics_grievances_v1";

export function loadCreatedGrievances() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function persist(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* localStorage unavailable — fall back to in-memory only for this session */
  }
}

export function addCreatedGrievance(record) {
  const list = loadCreatedGrievances();
  const next = [record, ...list];
  persist(next);
  return next;
}

export function deleteCreatedGrievance(id) {
  const next = loadCreatedGrievances().filter((r) => r.id !== id);
  persist(next);
  return next;
}

export function genGrievanceId() {
  return "GRV-U" + Date.now().toString(36).toUpperCase();
}
